
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programm/[[...slug]]",
      function () {
        return require("private-next-pages/programm/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programm/[[...slug]]"])
      });
    }
  